<div class="dialog">
  <div class="dialog-top">
    <h2 class="dialog-title short-text"> {{local_data.message}} </h2>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
      class="close-button" mat-dialog-close>
      <circle opacity="0.05" cx="20" cy="20" r="20" fill="#0080FF" />
      <path opacity="0.8"
        d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
        fill="#0080FF" />
      </svg>
    </div>

    <mat-dialog-content class="dialog-flex">
      <form [formGroup]="projectFormGroup">
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.projectName}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput formControlName="nameCtrl">
          @if (projectFormGroup.get('nameCtrl')?.hasError('required') &&
            (projectFormGroup.get('nameCtrl')?.touched || projectFormGroup.get('nameCtrl')?.dirty)) {
            <mat-hint class="error-hint">
              {{variables.mandatoryField}}
            </mat-hint>
          }
        </mat-form-field>


        @if (local_data.type === 'EDIT') {
          <label class="my-2 input-label">{{variables.region}}</label>
        }
        @else {
          <label class="my-2 input-label mandatory"><span>*</span> {{variables.region}}</label>
        }
        <mat-form-field
          [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput4, 'mat-form-field-invalid': invalidInput4}"
          class="form-field" appearance="outline">
          <mat-select formControlName="regionCtrl" (selectionChange)="changeClient($event.value)" name="region"
            required>
            @for (item of regions; track item; let i = $index) {
              <mat-option [value]="item.value">
                @if (i != 0) {
                  <span class="region-option">
                    <img class="region-flag" [src]="'assets/flags/' + item.value + '.svg'" [alt]="item.name">
                    <span class="region-name">{{item.name}}</span>
                  </span>
                }
                @if (i == 0) {
                  <span class="region-option-global">
                    <img class="region-flag global-flag" src="assets/images/World Globe-2.svg" alt="Global">
                    <span class="region-name-global">{{item.name}}</span>
                  </span>
                }
              </mat-option>
            }
          </mat-select>
          @if (projectFormGroup.get('regionCtrl').invalid && projectFormGroup.get('regionCtrl').touched) {
            <mat-hint class="error-hint"
              >
              {{variables.mandatoryField}}
            </mat-hint>
          }
        </mat-form-field>

        <label class="my-2 input-label">{{variables.maintenancePct}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput type="number" formControlName="maintenancePctCtrl" min="0" max="100">
          <span matTextSuffix>%</span>
          @if (projectFormGroup.get('maintenancePctCtrl')?.hasError('min') ||
               projectFormGroup.get('maintenancePctCtrl')?.hasError('max')) {
            <mat-hint class="error-hint">
              {{variables.valueBetween0And100}}
            </mat-hint>
          }
          @if (projectFormGroup.get('maintenancePctCtrl')?.hasError('required') &&
               (projectFormGroup.get('maintenancePctCtrl')?.touched || projectFormGroup.get('maintenancePctCtrl')?.dirty)) {
            <mat-hint class="error-hint">
              {{variables.mandatoryField}}
            </mat-hint>
          }
        </mat-form-field>

        @if (local_data.type === 'EDIT') {
          <label class="mb-2 input-label">{{variables.state}}</label>
        }
        <br>
          @if (local_data.type === 'EDIT') {
            <mat-radio-group formControlName="activeCtrl" class="form-field">
              <mat-radio-button [value]="true" style="margin-right: 15px;">{{variables.active}}</mat-radio-button>
              <mat-radio-button [value]="false">{{variables.inactive}}</mat-radio-button>
            </mat-radio-group>
          }
          @if (projectFormGroup.get('activeCtrl')?.hasError('required') &&
            (projectFormGroup.get('activeCtrl')?.touched || projectFormGroup.get('activeCtrl')?.dirty)) {
            <mat-hint class="error-hint">
              {{variables.mandatoryField}}
            </mat-hint>
          }
        </form>
        <div>
          <br>
            <mat-dialog-actions class="button-group">
              <app-button typeBtn="secondary" color="red" width="150px" textColor="white"
              message="{{variables.goBack}}" mat-dialog-close></app-button>
              <app-button typeBtn="primary" message="{{variables.save1}}" width="150px" (click)="doAction()"
              style="margin-left: 10px;"></app-button>
            </mat-dialog-actions>
          </div>
        </mat-dialog-content>

      </div>
